module.exports = __webpack_public_path__ + "img/97Ox25O.542018e4.svg";